"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissionRequiredMessage = exports.LabelDetailMessageElement = exports.LabelDetailMessageId = exports.LabelDetailDateElement = exports.LabelDetailAsset = exports.TextLinkWidgetLabelDetailAsset = exports.LabelDetailAuthorElementInner = exports.LabelDetailAuthorElement = exports.ExpandoWidgetWrapper = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const CertifiedBaseIcon_1 = require("@tableau/icons/CertifiedBaseIcon");
const KeyVerticalOutlineIcon_1 = require("@tableau/icons/KeyVerticalOutlineIcon");
const RESERVEDDatasourceCanInfoIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanInfoIcon");
const RESERVEDDatasourceCanWarningIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanWarningIcon");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const typestyle_1 = require("typestyle");
const MarkupStyles_1 = require("../../style/MarkupStyles");
const VizPortalStyles_1 = require("../../style/VizPortalStyles");
const UserDisplayComponent_1 = require("../../UserDisplayComponent");
const StringInterpolation_1 = require("../../utils/StringInterpolation");
const ViewerPaneLayoutComponents_1 = require("../../ViewerPaneLayoutComponents");
const LabelHelpers_1 = require("../LabelHelpers");
const Styles_1 = require("../Styles");
const LabelType_1 = require("./LabelType");
const TextWithIconIcon = (0, vizportalclient_common_components_1.divWithStyle)('TextWithIconIcon', {
    display: 'flex',
    flexShrink: 0,
    marginRight: widgets_1.TabStyles.Spacing.SmallSpace,
});
const TextWithIconContainer = (0, vizportalclient_common_components_1.divWithStyle)('TextWithIconContainer', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
});
function expandoButtonStyle(categoryType, isSevere) {
    switch (categoryType) {
        case 'warning':
            return {
                expandoType: isSevere ? 'yellow' : 'blue',
                icon: isSevere
                    ? react_1.default.createElement(RESERVEDDatasourceCanWarningIcon_1.RESERVEDDatasourceCanWarningIcon, { size: 14, alt: catalog_messages_1.Messages.DataQualityTypeWarning(), color: '#AC4B02' })
                    : react_1.default.createElement(RESERVEDDatasourceCanInfoIcon_1.RESERVEDDatasourceCanInfoIcon, { size: 14, alt: catalog_messages_1.Messages.DataQualityTypeWarning(), color: '#05628A' }),
            };
        case 'certification':
            return {
                expandoType: 'green',
                icon: react_1.default.createElement(CertifiedBaseIcon_1.CertifiedBaseIcon, { size: 14, alt: catalog_messages_1.Messages.ColumnHeaderCertification() }),
            };
        case 'sensitivity':
            return {
                expandoType: isSevere ? 'violet' : 'neutral',
                icon: isSevere
                    ? (react_1.default.createElement(KeyVerticalOutlineIcon_1.KeyVerticalOutlineIcon, { size: 14, style: { color: Styles_1.SensitiveLabelColor }, alt: catalog_messages_1.Messages.DataQualityTypeSensitiveData() }))
                    : (react_1.default.createElement(KeyVerticalOutlineIcon_1.KeyVerticalOutlineIcon, { size: 14, style: { color: Styles_1.SensitiveLabelNeutralColor }, alt: catalog_messages_1.Messages.DataQualityTypeSensitiveData() })),
            };
        case 'custom':
            return {
                expandoType: 'neutral',
            };
        default:
            (0, catalog_core_1.assertUnreachable)(categoryType);
            return null;
    }
}
function ExpandoWidgetWrapper(props) {
    var _a, _b;
    const [isExpanded, setIsExpanded] = (0, LabelHelpers_1.useExpand)(props.overrides);
    const { categoryType } = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext);
    const buttonStyleElements = expandoButtonStyle(categoryType, props.isSevere);
    const labelType = (_a = props.labelType) !== null && _a !== void 0 ? _a : '';
    return (react_1.default.createElement(widgets_1.ExpandoWidget, { expandoType: (_b = buttonStyleElements === null || buttonStyleElements === void 0 ? void 0 : buttonStyleElements.expandoType) !== null && _b !== void 0 ? _b : 'default', direction: widgets_1.ExpandoDirection.Down, isExpanded: isExpanded, onCollapse: () => setIsExpanded(false), onExpand: () => setIsExpanded(true), labelIcon: buttonStyleElements === null || buttonStyleElements === void 0 ? void 0 : buttonStyleElements.icon, label: react_1.default.createElement("strong", null, catalog_messages_1.Messages.Label_type_chip_message({
            MESSAGE_COUNT: props.length,
            LABEL_TYPE_LOC: labelType in LabelType_1.LabelType ? (0, LabelType_1.localizeLabelTypeName)((0, LabelType_1.stringtoLabelType)(labelType)) : labelType,
            MESSAGE_COUNT_LOC: catalog_messages_1.Formatters.formatCount(props.length),
        })), testId: 'expando-', alignment: 'right', className: (categoryType === 'custom' || (categoryType === 'sensitivity' && !props.isSevere))
            ? (0, typestyle_1.style)(Styles_1.ExpandoStyle)
            : undefined, style: {
            marginBottom: '3px',
            maxWidth: Styles_1.LabelExpandoMaxWidth,
        } },
        react_1.default.createElement(Styles_1.LabelExpandoContentDiv, null, props.children)));
}
exports.ExpandoWidgetWrapper = ExpandoWidgetWrapper;
function LabelDetailAuthorElement(props) {
    if (!props.author) {
        return null;
    }
    return (react_1.default.createElement(Styles_1.LabelDetailAuthorStyle, null,
        react_1.default.createElement(LabelDetailAuthorElementInner, Object.assign({}, props))));
}
exports.LabelDetailAuthorElement = LabelDetailAuthorElement;
function LabelDetailAuthorLink(props) {
    return react_1.default.createElement("a", { href: props.url, target: '_blank', className: VizPortalStyles_1.linkClass, title: props.name, rel: 'noreferrer' }, props.name);
}
function LabelDetailAuthorElementInner(props) {
    const { linksDisabled } = react_1.default.useContext(LabelHelpers_1.LabelButtonContext);
    if (!props.author) {
        return null;
    }
    const userElement = (linksDisabled || !props.author.domain)
        ? react_1.default.createElement(UserDisplayComponent_1.UserTextDisplayComponent, { user: props.author })
        : react_1.default.createElement(UserDisplayComponent_1.UserLinkDisplayComponent, { user: props.author, linkComponent: LabelDetailAuthorLink });
    const name = '[AUTHOR_NAME_TOKEN]';
    const span = react_1.default.createElement("span", { key: 'author', "data-tb-test-id": 'Data-Quality-Detail-Author' }, userElement);
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, StringInterpolation_1.interpolateString)(catalog_messages_1.Messages.DataQualityAuthor({ name }), { 'AUTHOR_NAME_TOKEN': span })));
}
exports.LabelDetailAuthorElementInner = LabelDetailAuthorElementInner;
function TextLinkWidgetLabelDetailAsset(props) {
    var _a, _b, _c, _d, _e;
    const { content: baseContent } = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext);
    if (props.assetName == null)
        return getPermissionRequiredMessage();
    const iconComponent = (0, LabelHelpers_1.assetTableauIconForType)((_a = props.subjectArea) !== null && _a !== void 0 ? _a : props.assetType, props.remoteType);
    return (react_1.default.createElement(Styles_1.LabelDetailAssetStyle, null, props.assetUrl
        ? (react_1.default.createElement(widgets_1.TextLinkWidget, { href: props.assetUrl, kind: widgets_1.TextLinkKind.Standalone, target: '_blank', testId: 'text-link-widget-with-icon' },
            react_1.default.createElement(TextWithIconContainer, null,
                react_1.default.createElement(TextWithIconIcon, null, iconComponent), (_c = (_b = props.assetName) !== null && _b !== void 0 ? _b : baseContent === null || baseContent === void 0 ? void 0 : baseContent.contentName) !== null && _c !== void 0 ? _c : null)))
        : (react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: (_e = (_d = props.assetName) !== null && _d !== void 0 ? _d : baseContent === null || baseContent === void 0 ? void 0 : baseContent.contentName) !== null && _e !== void 0 ? _e : null, iconComponent: iconComponent, iconSize: 'small' }))));
}
exports.TextLinkWidgetLabelDetailAsset = TextLinkWidgetLabelDetailAsset;
function LabelDetailAsset(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (props.assetName == null)
        return getPermissionRequiredMessage();
    const iconComponent = (0, LabelHelpers_1.assetIconForType)((_a = props.subjectArea) !== null && _a !== void 0 ? _a : props.assetType, props.remoteType);
    if (props.parentName) {
        const renderText = props.assetName + ' (table ' + props.parentName + ')';
        return (react_1.default.createElement(Styles_1.LabelDetailAssetStyle, null, props.assetUrl
            ? (react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineLinkWithSubLinkIcon, { linkText: (_b = props.assetName) !== null && _b !== void 0 ? _b : null, linkHref: (_c = props.assetUrl) !== null && _c !== void 0 ? _c : '', iconComponent: iconComponent, iconSize: 'small', subLinkText: (_d = props.parentName) !== null && _d !== void 0 ? _d : null, subLinkHref: (_e = props.parentUrl) !== null && _e !== void 0 ? _e : '', subPrefixText: ' (table ', subSuffixText: ')' }))
            : (react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: renderText, iconComponent: iconComponent, iconSize: 'small' }))));
    }
    return (react_1.default.createElement(Styles_1.LabelDetailAssetStyle, null, props.assetUrl
        ? (react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineLinkWithIcon, { linkText: (_f = props.assetName) !== null && _f !== void 0 ? _f : null, linkHref: (_g = props.assetUrl) !== null && _g !== void 0 ? _g : '', iconComponent: iconComponent, iconSize: 'small' }))
        : (react_1.default.createElement(ViewerPaneLayoutComponents_1.SingleLineTextWithIcon, { text: props.assetName || null, iconComponent: iconComponent, iconSize: 'small' }))));
}
exports.LabelDetailAsset = LabelDetailAsset;
function LabelDetailDateElement(props) {
    return (react_1.default.createElement(Styles_1.LabelDetailDateStyle, null, props.updatedAt));
}
exports.LabelDetailDateElement = LabelDetailDateElement;
exports.LabelDetailMessageId = 'data-quality-detail-message-id';
function LabelDetailMessageElement(props) {
    if (props.assetName === null) {
        return (react_1.default.createElement(Styles_1.LabelDetailMessageStyle, { id: exports.LabelDetailMessageId }, catalog_messages_1.Messages.PermissionRequiredMessage()));
    }
    return (react_1.default.createElement(Styles_1.LabelDetailMessageStyle, null,
        react_1.default.createElement(MarkupOrSplitString, Object.assign({}, props))));
}
exports.LabelDetailMessageElement = LabelDetailMessageElement;
function MarkupOrSplitString(props) {
    const { linksDisabled } = react_1.default.useContext(LabelHelpers_1.LabelButtonContext);
    const messageOrBlank = props.message || '';
    return react_1.default.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: messageOrBlank, linksDisabled: linksDisabled });
}
function getPermissionRequiredMessage() {
    const name = catalog_messages_1.Messages.PermissionRequired();
    return react_1.default.createElement("span", { key: 'asset-' + name, style: Styles_1.LabelDetailPermissionRequired }, name);
}
exports.getPermissionRequiredMessage = getPermissionRequiredMessage;
//# sourceMappingURL=LabelPopoverDetail.js.map